import { BRAND, WHATSAPP_NUMBER } from "@/config";

const SECTIONS = [
  {
    title: "What we collect",
    body: "Your name, WhatsApp number, delivery address and the products you add to your order. Nothing else is asked for and we never store card or bank details — payments are settled directly with you.",
  },
  {
    title: "Why we collect it",
    body: "To prepare your quotation, confirm your order on WhatsApp, arrange courier delivery, share the tracking number, and send you updates about new blanks and offers when you have signed up with us.",
  },
  {
    title: "WhatsApp messages",
    body: "We message you on the WhatsApp number you register with us — order confirmations, courier tracking, and occasional updates about new products or offers. Reply STOP on WhatsApp at any time and we stop the update messages immediately; your order messages continue only while an order is in progress.",
  },
  {
    title: "Who can see your details",
    body: "Only our own team. We do not sell, rent or share your details with anyone for advertising. Your address is shared with the courier company solely to deliver your parcel.",
  },
  {
    title: "How long we keep it",
    body: "Order records are kept as long as the law requires them for our accounts. You can ask us to delete your account details at any time and we will remove everything we are not legally required to keep.",
  },
  {
    title: "Your choices",
    body: `Write to us on WhatsApp at +${WHATSAPP_NUMBER} to see, correct or delete your details, or to stop marketing messages. We answer within 2 working days.`,
  },
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="min-h-screen bg-[#0A0B0E] px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <a
          href="/"
          data-testid="privacy-back-link"
          className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-cyan-300"
        >
          ← Back to {BRAND}
        </a>
        <h1 className="mt-6 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Privacy Policy</h1>
        <p className="mt-3 text-base text-slate-400">
          {BRAND} sells sublimation blanks to businesses across India. This page explains, in plain words, what we do
          with the details you give us.
        </p>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((section) => (
            <section key={section.title} data-testid={`privacy-section-${section.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <h2 className="text-lg font-bold text-slate-100">{section.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{section.body}</p>
            </section>
          ))}
        </div>
        <p className="mt-16 border-t border-white/5 pt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-600">
          Last updated {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })} · wa.me/{WHATSAPP_NUMBER}
        </p>
      </div>
    </main>
  );
}
